/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react';
import Localized from '../../../../shared/components/Localized';
import moment from 'moment';
import humanizeDuration from 'humanize-duration';
import Linkify from 'react-linkify';
import { TIMESTAMP_FORMAT } from "../../../../shared/utils/dates";
import FooterTimeStamp from '../../FooterTimestamp';
import { Wrapper, TitleWrapper, Title, TimeStamp, Duration } from './styles.js';

const ImpactEnd = ({ feedItem, region, missingTranslations }) => (
  <Linkify properties={{ target: '_blank' }}>
    <Wrapper severity={feedItem.severity}>
      <TitleWrapper>
        <div>
          <Title>
            <Localized
              modelName='endMaintenance'
              modelKey='endMaintenanceTranslation'
              modelAttribute='label'
              missingTranslations={missingTranslations}/>
          </Title>
        </div>
        <TimeStamp severity={feedItem.severity}>
          { moment.tz(feedItem.dateTime, region).format(TIMESTAMP_FORMAT) }
        </TimeStamp>
      </TitleWrapper>
      <Duration severity={feedItem.severity}>
        <Localized
          modelName='modal'
          modelKey='duration'
          modelAttribute='label'
          missingTranslations={missingTranslations}
        />
        :&nbsp;
        <span>
          { humanizeDuration(feedItem.duration, { largest: 2, round: true,
            units: feedItem.duration < 600000 ? ['y', 'mo', 'w', 'd', 'h', 'm', 's'] : ['y', 'mo', 'w', 'd', 'h', 'm']
          }) }
        </span>
      </Duration>
      <FooterTimeStamp 
        createdTime= {feedItem.postTime}
        lastModifiedTime={feedItem.postUpdatedTime}
        region= {region} 
        missingTranslations={missingTranslations}
      />
    </Wrapper>
  </Linkify>
);

export default ImpactEnd;
